export const UPDATE_SCHEDULE = 'calendar:updateSchedule';

export function updateSchedule(lastDate, lastView) {
    console.log('updateSchedule',lastDate, lastView)
    return {
        type: UPDATE_SCHEDULE,
        payload: {
            calendar: {
                lastDate: lastDate,
                lastView: lastView
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/calendar-actions.js